import { useState } from 'react';
import {FiSearch} from 'react-icons/fi';
import './styles.css';
import api from './services/api';

function App() {
  const [input, setInput] = useState('');
  const [cep, setCep] = useState({});


async function handleSearch() {
  if (input === '') {
    alert("Insira o cep!")
    return;
  }

  try {
    const response = await api.get(`${input}/json`);
    setCep(response.data)
    setInput("");

  } catch {
    alert("Ops! Erro ao buscar. Tente novamente!")
    setInput("")
  }
}

  return (
    <div className="container">
      <h1 className='title'>BUSCA CEP</h1>

      <div className="containerInput">
        <input type="text" placeholder="Digite o cep aqui..." value={input} onChange={(e) => setInput(e.target.value)} />
        <button className="buttonSearch">
          <FiSearch size={25} color='#fff' onClick={handleSearch}/>
        </button>
      </div>

      {Object.keys(cep).length > 0 && (
        <main className='main'>
        <h2>Cep: {cep.cep}</h2>
        <span>Local: {cep.logradouro}</span>
        <span>Bairro: {cep.bairro}</span>
        <span>Cidade: {cep.localidade}</span>
        <span>Estado: {cep.uf}</span>
        <span>DDD: {cep.ddd}</span>
        <span>Complemento: {cep.complemento}</span>
      </main>
      )}
    </div>
  );
}

export default App;